import React from 'react';
import type { BydaUsagePolicySummary } from '@/services/bydaService';

type BydaUsageSummaryProps = {
  policy: BydaUsagePolicySummary | null;
  heading: string;
  subheading: string;
};

export default function BydaUsageSummary({ policy, heading, subheading }: BydaUsageSummaryProps) {
  if (!policy) {
    return null;
  }

  const mutedStyle: React.CSSProperties = {
    color: 'var(--color-muted, #667085)',
    fontSize: '0.92rem',
  };

  return (
    <div
      style={{
        border: '1px solid var(--color-border)',
        borderRadius: '16px',
        padding: '16px',
        background: 'linear-gradient(180deg, rgba(23, 59, 132, 0.05) 0%, rgba(255,255,255,0.98) 100%)',
        display: 'grid',
        gap: '14px',
      }}
    >
      <div>
        <div style={{ fontWeight: 700 }}>{heading}</div>
        <div style={mutedStyle}>{subheading}</div>
      </div>

      <div
        style={{
          display: 'grid',
          gap: '12px',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        }}
      >
        {policy.members.map((member) => (
          <div
            key={member.email}
            style={{
              border: '1px solid rgba(23, 59, 132, 0.12)',
              borderRadius: '14px',
              padding: '12px 14px',
              background: 'rgba(255,255,255,0.96)',
              display: 'grid',
              gap: '4px',
            }}
          >
            <strong>{member.label}</strong>
            <span>{member.usedToday} used / {member.dailyLimit} allowed today</span>
            <span style={mutedStyle}>{member.remainingToday} remaining today</span>
          </div>
        ))}
        <div
          style={{
            border: '1px solid rgba(23, 59, 132, 0.12)',
            borderRadius: '14px',
            padding: '12px 14px',
            background: 'rgba(255,255,255,0.96)',
            display: 'grid',
            gap: '4px',
          }}
        >
          <strong>Team today</strong>
          <span>{policy.totals.usedToday} used / {policy.limits.totalPerDay} allowed</span>
          <span style={mutedStyle}>{policy.totals.remainingToday} remaining today</span>
        </div>
        <div
          style={{
            border: '1px solid rgba(23, 59, 132, 0.12)',
            borderRadius: '14px',
            padding: '12px 14px',
            background: 'rgba(255,255,255,0.96)',
            display: 'grid',
            gap: '4px',
          }}
        >
          <strong>This month</strong>
          <span>{policy.totals.usedThisMonth} used / {policy.limits.totalPerMonth} allowed</span>
          <span style={mutedStyle}>{policy.totals.remainingThisMonth} remaining this month</span>
        </div>
      </div>
    </div>
  );
}
